export const INFO_MESSAGE_TYPES = {
  DEFAULT: 'default',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error',
  NONE: 'none'
}
